"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = default_1;
const either_1 = require("../../types/either");
const getMinMaxPagesForBookProject_1 = __importDefault(require("./getMinMaxPagesForBookProject"));
const getBookInteriorPageCount_1 = __importDefault(require("./getBookInteriorPageCount"));
const printables_1 = require("../printables");
const printableModifications_1 = require("./update/printableModifications");
function default_1(project, action, template, art) {
  const [minPageCount, maxPageCount] = (0, getMinMaxPagesForBookProject_1.default)(template, art.category);
  if (!minPageCount && !maxPageCount) {
    return (0, either_1.left)(new Error("We can't remove printables from books that haven't variable page count"));
  }
  //error for min printables
  const currentPageCount = (0, getBookInteriorPageCount_1.default)(project.printableGroups, art.category);
  if (currentPageCount - action.printableIds.length < minPageCount) {
    return (0, either_1.left)(new Error(`Could not remove printable(s) from book project ${project.id} because that would put it below the minimum number of pages.`));
  }
  const interiorPrintableGroupIndex = project.printableGroups.findIndex(p => p.type === 'interior');
  if (interiorPrintableGroupIndex < 0) {
    return (0, either_1.left)(new Error(`Could not find interior printable group for project ${project.id}`));
  }
  const newInteriorPrintableGroup = project.printableGroups[interiorPrintableGroupIndex].printables.filter(p => !action.printableIds.includes(p.id));
  project.printableGroups[interiorPrintableGroupIndex].printables = newInteriorPrintableGroup;
  const updateCoverPrintableIfNeededResult = (0, printables_1.updateBookCoverPrintableIfNeeded)(template, project, action.timestamp);
  if (updateCoverPrintableIfNeededResult.isLeft()) {
    return (0, either_1.left)(updateCoverPrintableIfNeededResult.value);
  }
  const numInteriorPrintables = project.printableGroups[interiorPrintableGroupIndex].printables.length;
  project = (0, printableModifications_1.modifyProjectForPrintableModifications)(project, art, numInteriorPrintables);
  const updatedEntities = [project];
  if (updateCoverPrintableIfNeededResult.isRight() && !!updateCoverPrintableIfNeededResult.value) {
    updatedEntities.push(updateCoverPrintableIfNeededResult.value);
  }
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities: updatedEntities
  });
}